import { QUERY_KEY } from '@constants/queries';

import { useQuery } from '@tanstack/react-query';
import { GET } from '@lib/axios';
import { PublicLiveBlog } from '@utils/typesPages/types';
import { CACHE_TIME_TANSTACK } from '@constants/configurations';

export const fetchLiveBlogBySlug = async (slug: string) => {
  const { data } = await GET<PublicLiveBlog>(`/api/live-blogs/${slug}`);

  return data;
};

export const useFetchLiveBlogBySlug = (slug: string) => {
  return useQuery({
    queryKey: [QUERY_KEY.FETCH_NEWS_BY_SLUG, slug],
    queryFn: () => fetchLiveBlogBySlug(slug),
    enabled: !!slug,
    refetchInterval: CACHE_TIME_TANSTACK,
    gcTime: CACHE_TIME_TANSTACK,
  });
};
